// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestedUserCard-cls1_78L","cls2":"SuggestedUserCard-cls2_4mT SuggestedUserCard-cls1_78L"};